import { useState, useEffect } from "react";
import { DownloadSimple, X, Export, PlusSquare } from "@phosphor-icons/react";

const KEY = "vitalis-install-dismissed";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(KEY)) return;
    let interval;
    const showWhenClear = () => {
      interval = setInterval(() => {
        if (!document.querySelector('[data-testid="guided-tour"]')) {
          clearInterval(interval);
          setShow(true);
        }
      }, 1500);
    };
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      showWhenClear();
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    let timer;
    if (isIOS()) {
      timer = setTimeout(() => {
        setIos(true);
        showWhenClear();
      }, 3000);
    }
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setShow(false);
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") localStorage.setItem(KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="install-prompt"
      className="fixed z-50 left-4 right-4 bottom-[142px] sm:left-auto sm:right-6 sm:bottom-6 sm:w-[360px] bg-surface border border-border rounded-3xl shadow-xl p-5"
    >
      <button data-testid="install-dismiss-btn" onClick={dismiss} className="absolute top-3.5 right-3.5 text-muted2 hover:text-ink transition-colors">
        <X size={16} weight="bold" />
      </button>
      <div className="flex items-start gap-3">
        <img src="/logo192.png" alt="Ikavio" className="w-11 h-11 rounded-2xl shrink-0" />
        <div className="min-w-0">
          <p className="font-medium text-[15px]">Install Ikavio</p>
          {ios ? (
            <p className="text-sm text-muted2 mt-1 leading-relaxed">
              Get the full app experience with notifications: tap{" "}
              <Export size={14} weight="bold" className="inline align-[-2px]" color="var(--brand)" /> <span className="font-medium text-ink">Share</span>, then{" "}
              <PlusSquare size={14} weight="bold" className="inline align-[-2px]" color="var(--brand)" /> <span className="font-medium text-ink">Add to Home Screen</span>.
            </p>
          ) : (
            <p className="text-sm text-muted2 mt-1">Add Ikavio to your home screen — full-screen, faster, with push notifications.</p>
          )}
          {!ios && (
            <button
              data-testid="install-confirm-btn"
              onClick={install}
              className="mt-3 inline-flex items-center gap-1.5 bg-brand text-white rounded-full px-4 py-2 text-sm font-medium hover:bg-ink transition-colors"
            >
              <DownloadSimple size={15} weight="bold" /> Install app
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
